export default class ValidationError extends Error {}